//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useState, useRef } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  CardContent,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  MoreVert,
} from '@mui/icons-material';

// === HOOKS ===

// === COMPONENTS ===
import { TaskSubmitMenu } from './components/TaskSubmitMenu/TaskSubmitMenu';
import { DetachPanelMenu } from './components/DetachPanelMenu/DetachPanelMenu';
import { FieldSnippetsMenu } from './components/FieldSnippetsMenu/FieldSnippetsMenu';

//#endregion

//-----------------------------------------------------------------
export function UserSettings() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const ref    = useRef();
  const theme  = useTheme();

  const [is_open, setIsOpen] = useState(false);

  const _styles = {
    container: {
      display    : 'flex'   ,
      paddingTop : '0.5rem' ,
      justifyContent : 'center' ,
      aligntItems    : 'center' ,

      zIndex: '50',
    },
    dropdown: {
      display : is_open ? '' : 'none',
      width   : '12rem',
      top     : '5.5rem',
      right   : '2rem',
      position: 'absolute',
      // padding:'0.5rem',
    },
    icon: {
      color: theme.palette.primary.main,
    },
    info: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: '-0.5px 0.5px 3px black',
      width: '100%',
      padding:'0.5rem',
      borderRadius: '0rem 0.5rem 0.5rem 0.5rem',
      
      "&:last-child": {
        paddingBottom: 0.5,
      },
    }
  }

  //#endregion

  useEffect(() => {
    if(is_open) document.addEventListener   ( 'click', handleClickOutside, true );
    else        document.removeEventListener( 'click', handleClickOutside, true );

    return () => {
      if(is_open) document.removeEventListener('click', handleClickOutside, true);
    };
  }, [is_open]);

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function toggleDetails() {
    //-----------------------------------------------------------------
    setIsOpen(!is_open);
  };

  //-----------------------------------------------------------------
  function handleClickOutside(event) {
    //-----------------------------------------------------------------
    if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
    }
  }

  //#endregion
  
  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display(){
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} ref={ref}>
        <Tooltip>
          <IconButton name='user_settings' aria-label='User settings' sx={_styles.icon} onClick={toggleDetails}>
            <MoreVert fontSize='large' />
          </IconButton>
        </Tooltip>
        <Box sx={_styles.dropdown}>
          <CardContent sx={_styles.info}>
            <DetachPanelMenu />
            <Divider />
            <TaskSubmitMenu />
            <Divider />
            <FieldSnippetsMenu />
          </CardContent>
        </Box>
      </Box>
    )
  }

  //#endregion

  return display();
}
